import { render } from "./PathNotFound.vue?vue&type=template&id=34a95c78"
import script from "./PathNotFound.vue?vue&type=script&lang=js"
export * from "./PathNotFound.vue?vue&type=script&lang=js"

import "./PathNotFound.vue?vue&type=style&index=0&id=34a95c78&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__